<template>
  <Modal
    @close="$emit('close')"
    :title="'Descargar Reportes'"
    classes="col-lg-5"
  >
    <div slot="body" class="body">
      <DownloadReportsView />
    </div>
  </Modal>
</template>

<script>
import Modal from "@/components/Modal";
import DownloadReportsView from "@/components/userProfile/DownloadReportsView";

export default {
  name: "ReportsModal",
  components: {
    Modal,
    DownloadReportsView,
  },
};
</script>
